import { generateApiPath } from '@scouts/helpers'

import { CompanyDTO } from '@/models'

import { apiSlice } from '../api-slice'
import { ENDPOINTS } from '../endpoints'
import { ApiTags } from '../tags'

const extendedApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getCompany: builder.query<CompanyDTO, { userId?: number }>({
            query: ({ userId }) => ({
                method: 'GET',
                url: generateApiPath(ENDPOINTS.COMPANY.GET, { userId }),
            }),
            providesTags: [ApiTags.Company],
        }),
        createOrUpdateCompany: builder.mutation<CompanyDTO, CompanyDTO>({
            query: (data) => ({
                method: 'PUT',
                url: generateApiPath(ENDPOINTS.COMPANY.PUT, { userId: data.userId }),
                data,
            }),
            invalidatesTags: [ApiTags.Company],
        }),
    }),
})

export const { useGetCompanyQuery, useCreateOrUpdateCompanyMutation } = extendedApi
